import { render, staticRenderFns } from "./SectionBox.vue?vue&type=template&id=b59d8202&scoped=true"
import script from "./SectionBox.vue?vue&type=script&lang=js"
export * from "./SectionBox.vue?vue&type=script&lang=js"
import style0 from "./SectionBox.vue?vue&type=style&index=0&id=b59d8202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59d8202",
  null
  
)

export default component.exports